module.exports = __webpack_public_path__ + "static/media/Semantic Pixelator.ffd477ac.mp4";